import { List, Map, fromJS } from 'immutable';

export function request(state, { id }) {
    id = parseInt(id, 10);

    let adjust = state.get('adjust') || Map();
    let user = adjust.get(id) || Map();

    user = user
            .set('state', 'IN_PROGRESS')
            .set('errors', void 0);

    return state.set(
        'adjust', adjust.set(id, user)
    );
}

export function error(state, { id, errors }) {
    id = parseInt(id, 10);

    let adjust = state.get('adjust') || Map();
    let user = adjust.get(id) || Map();

    user = user
            .set('state', 'ERROR')
            .set('errors', fromJS(errors));

    return state.set(
        'adjust', adjust.set(id, user)
    );
}

export function finish(state, { id, transaction, customer }) {
    id = parseInt(id, 10);

    let adjustEl = state.get('adjust') || Map();
    let user = adjustEl.get(id) || Map();

    user = user
            .set('state', 'FINISHED')
            .set('data', fromJS(transaction))
            .set('errors', void 0);

    state = state.set(
        'adjust', adjustEl.set(id, user)
    );

    if (!customer) {
        return state;
    }

    return state.setIn([ 'list', id, 'data' ], fromJS(customer));
}

export function clear(state, { id }) {
    id = parseInt(id, 10);

    return state.set(
        'adjust',
        (state.get(id) || Map()).set(id, void 0)
    );
}
